import React from 'react';
import { Card, Dropdown } from '@bynder/design-system';
import { IconAddPerson, IconDelete, IconMore, IconRename } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import useAccessRights from 'packages/hooks/useAccessRights';
import { ActionStatus, CategoryAction, Entity } from 'packages/hooks/useAccessRights/types';
import { Props } from './types';

const CategoryContextMenu = ({ category, menuActions }: Props) => {
    const { translate } = useTranslate();
    const { isEntityActionAllowed } = useAccessRights();

    return (
        <Dropdown
            trigger={({ isOpen, ...triggerProps }) => (
                <Card.ContextActionButton
                    aria-label={translate('pages.categories.menu')}
                    isPressed={isOpen}
                    {...triggerProps}
                >
                    <IconMore />
                </Card.ContextActionButton>
            )}
            position="bottom-left"
        >
            {isEntityActionAllowed(CategoryAction.RENAME, Entity.CATEGORY, category.grantedPermissions) !==
                ActionStatus.NOT_ALLOWED && (
                <Dropdown.Item
                    isDisabled={
                        isEntityActionAllowed(CategoryAction.RENAME, Entity.CATEGORY, category.grantedPermissions) ===
                        ActionStatus.DISABLED
                    }
                    icon={<IconRename />}
                    onClick={() => menuActions.setEditDetailsModalCategory(category)}
                >
                    {translate('pages.categories.menu.editDetails')}
                </Dropdown.Item>
            )}
            <Dropdown.Item
                icon={<IconAddPerson />}
                onClick={() => menuActions.setShareModalCategory && menuActions.setShareModalCategory(category)}
            >
                {translate('pages.categories.menu.share')}
            </Dropdown.Item>
            {isEntityActionAllowed(CategoryAction.DELETE, Entity.CATEGORY, category.grantedPermissions) !==
                ActionStatus.NOT_ALLOWED && (
                <>
                    <Dropdown.Divider />
                    <Dropdown.Item
                        isDisabled={
                            isEntityActionAllowed(
                                CategoryAction.DELETE,
                                Entity.CATEGORY,
                                category.grantedPermissions,
                            ) === ActionStatus.DISABLED
                        }
                        icon={<IconDelete />}
                        onClick={() => menuActions.setDeleteModalCategory(category)}
                    >
                        {translate('pages.categories.menu.delete')}
                    </Dropdown.Item>
                </>
            )}
        </Dropdown>
    );
};

export default CategoryContextMenu;
